<div class="row">
    <div class="col-12">

        <form [formGroup]="videoForm">
            <aw-wizard #wizard class="arc-wizard" navBarLocation="left">

                <aw-wizard-step stepTitle="TITOLO">
                    <div class="row">
                        <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="title">TITOLO*</label>
                                    <input formControlName="title" type="text" class="form-control" id="title" aria-describedby="title" placeholder="">
                                    <small id="titleHelp" class="form-text text-muted">Scrivi una titolo</small>
                                </div>
                                <div class="form-group">
                                    <label for="subtitle">SOTTOTITOLO</label>
                                    <textarea  formControlName="subtitle" class="form-control" id="subtitle" aria-describedby="subtitleHelp"></textarea>
                                    <small id="subtitleHelp" class="form-text text-muted">Scrivi un sottotitolo o un indicazione aggiuntiva</small>
                                </div>
                                <div class="form-group">
                                    <label for="info">INFO</label>
                                    <app-tinymce formControlName="info" id="info" aria-describedby="infoHelp"></app-tinymce>
                                    <small id="infoHelp" class="form-text text-muted">Inserisci le info della tua Interazione</small>
                                </div>
                                <h6>Coordinate:</h6>
                                <div class="form-group">
                                    <label for="lat">LATITUDINE</label>
                                    <input formControlName="lat" type="text" class="form-control" id="lat" aria-describedby="latHelp" placeholder="41.89884227456026">
                                    <small id="latHelp" class="form-text text-muted">Inserisci la latitudine</small>
                                </div>
                                <div class="form-group">
                                    <label for="lat">LONGITUDINE</label>
                                    <input formControlName="lng" type="text" class="form-control" id="lng" aria-describedby="lngHelp" placeholder="12.52539241745996">
                                    <small id="lngHelp" class="form-text text-muted">Longitudine</small>
                                </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateTitle()" (click)="setTitle()">Avanti</button>
                        </div>
                    </div>
                </aw-wizard-step>

                <aw-wizard-step stepTitle="AUDIO">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="hasImage">VUOI INSERIRE UN'IMMAGINE?</label>
                                <div class="switch m-r-10">
                                    <input type="checkbox" id="hasImage" formControlName="hasImage" aria-describedby="hasImageHelp">
                                    <label for="hasImage" class="cr"></label>
                                </div>
                                <small id="hasImageHelp" class="form-text text-muted">La Interaction prevede un'immagine?</small>
                            </div>
                            <div class="form-group" *ngIf="f.hasImage.value">
                                <label>IMMAGINE</label>
                                <app-media-manager [formatsAllowed]="'.jpeg,.jpg,.png'" [filePath]="interaction.image" (onFileSelect)="setImageUrl($event, 'featuredImage')"></app-media-manager>
                            </div>
                            <div class="form-group">
                                <label>FILE AUDIO</label>
                                <app-media-manager [maxSize]="5" [formatsAllowed]="'.mp3,.m4a,.wav'" [filePath]="interaction.interactionData && interaction.interactionData.audioUrl" (onFileSelect)="setAudioFile($event)"></app-media-manager>
                            </div>
                        </div>

                        <div class="col-sm-12 mt-3 d-flex justify-content-end">
                            <button type="button" class="btn btn-primary" awNextStep [disabled]="!validateContenuto()" (click)="onAddInteraction()">Salva</button>
                        </div>
                    </div>
                </aw-wizard-step>
            
            </aw-wizard>
        </form>
    </div>
</div>

<!-- {{interaction | json}} -->